module.exports = __webpack_public_path__ + "static/img/1_2_1.2d8d2d21.jpg";